<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="" v-if="$hasPermission([62, 173, 123])">
          <el-button
            slot="beforeDefinedSearch"
            type="success"
            @click="addFile">添加文件</el-button>
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-form-item label="所属国家">
            <el-select v-model="searchData.country" clearable placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="searchData.name" placeholder="文件标题/文件名" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="() => {this.refresh = true;}">查询</el-button>
          </el-form-item>
        </el-form>
        <jm-tableList
          url="/index/europe_file/getFileList"
          :search-data="searchData"
          :refresh.sync="refresh">
          <el-table-column
            slot="file_name"
            label="文件名">
            <template slot-scope="scope">
              <span style="color: #6495ED"><img :src="scope.row.file_icon" align="absmiddle" /> {{ scope.row.file_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            slot="lastColumn"
            label="操作"
            :width="$hasPermission([62, 173, 123]) ? 220 : 100">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="editFile(scope)" v-if="$hasPermission([62, 173, 123])">编辑</el-button>
              <a :download="scope.row.file_name" :href="`/${scope.row.file_path}`">
                <el-button size="small" type="success">下载</el-button>
              </a>
              <el-button size="small" type="danger" @click="handleDelete(scope)" v-if="$hasPermission([62, 173, 123])">删除</el-button>
            </template>
          </el-table-column>
        </jm-tableList>
      </div>
    </div>
    <el-dialog
      title="添加文件"
      :visible.sync="dlgCreateVisible"
    >
      <el-form label-width="100px" >
        <el-form-item label="文件标题：">
          <el-input v-model="name" autofocus clearable class="jm-input280"></el-input>
        </el-form-item>
        <el-form-item label="上传文件：">
          <jm-upload
            class="upload-button"
            action="/newfib.php/index/europe_file/uploadFile"
            :on-success="uploadSuccess"
            :file-list="fileList"
            :show-file-list="true">
            <el-button size="small" type="primary">上传文件</el-button>
          </jm-upload>
        </el-form-item>
        <el-form-item label="所属国家">
          <el-select v-model="country" placeholder="请选择">
            <el-option
              v-for="item in ds.country"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgCreateVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreate"
                   :disabled="fileList.length === 0 || !name"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑文件"
      :visible.sync="dlgEditVisible"
    >
      <el-form label-width="100px" >
        <el-form-item label="文件标题：">
          <el-input v-model="name" autofocus clearable class="jm-input280"></el-input>
        </el-form-item>
        <el-form-item label="所属国家：">
          <el-select v-model="country" placeholder="请选择">
            <el-option
              v-for="item in ds.country"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit"
                   :disabled="!name"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style>
  .el-dialog{
    width: 30%;
    min-width: 450px;
  }
  .el-form-item {
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false,
      dlgCreateVisible: false,
      dlgEditVisible: false,
      ds: {},
      searchData: { name: '', country: '' },
      id: 0,
      name: '',
      country: '',
      fileList: []
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    uploadSuccess(response, file) {
      if (response.result === -1) {
        this.$message.error(response.msg);
        this.fileList = [];
      } else {
        if (this.name === '') {
          this.name = file.name.substr(0, file.name.lastIndexOf('.'));
        }
        this.fileList = [file];
      }
    },
    handleCreate() { // 新建
      this.$http._post({
        url: 'index/europe_file/saveFile',
        data: {
          name: this.name,
          file: this.fileList[0].response.data,
          country: this.country
        },
      }).then((res) => {
        if (res.result === 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.dlgCreateVisible = false;
          this.refresh = true;
        }
      });
    },
    handleEdit() { // 编辑
      this.$http._post({
        url: 'index/europe_file/saveFile',
        data: {
          id: this.id,
          name: this.name,
          country: this.country
        },
      }).then((res) => {
        if (res.result === 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.dlgEditVisible = false;
          this.refresh = true;
        }
      });
    },
    handleDelete(scope) { // 删除
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/europe_file/delFile',
          data: { id: scope.row.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.refresh = true;
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addFile() { // 添加
      this.dlgCreateVisible = true;
      this.dlgEditVisible = false;
      this.id = 0;
      this.name = '';
      this.country = '';
      this.fileList = [];
    },
    editFile(scope) { // 编辑
      this.dlgCreateVisible = false;
      this.dlgEditVisible = true;
      this.id = scope.row.id;
      this.name = scope.row.name;
      this.country = String(scope.row.country);
    },
    editFileOrder(scope) {
      this.id = scope.row.id;
      this.name = scope.row.name;
      this.country = String(scope.row.country);
      this.handleEdit();
    },
    fetchData() {
      this.$http
        ._get({
          url: '/index/europe_file/dictData'
        })
        .then(({ data }) => {
          this.ds = data;
        });
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
